import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../Shared/Icon/Icon'

const ActionsSection = ({
  conversations, selectAll, clearFilters, moveCheckedToArchive, hideMoveToArchiveButton,
}) => {
  const isAllChecked = conversations.filter(c => c.attributes.checked).length === conversations.length

  return (
    <div className="container__actions">
      {
        !hideMoveToArchiveButton
          && (
          <span className="container-actions__action">
            <input
              type="checkbox"
              id="select-all"
              className="checkbox"
              checked={isAllChecked}
              onChange={selectAll}
            />
            <label htmlFor="select-all" className="select-all-label">Select All</label>
          </span>
          )
      }
      <span className="container-actions__action" onClick={clearFilters}>
        <Icon type="filter" />
        Clear filters
      </span>
      {
          !hideMoveToArchiveButton
            && (
            <span className="container-actions__action u-float-right" onClick={moveCheckedToArchive}>
              Move to archive <Icon type="archive" />
            </span>
            )
        }
    </div>
  )
}

ActionsSection.propTypes = {
  conversations: PropTypes.array.isRequired,
  selectAll: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  moveCheckedToArchive: PropTypes.func.isRequired,
  hideMoveToArchiveButton: PropTypes.bool.isRequired,
}

export default ActionsSection
